import * as React from 'react';
import logo from '../../../images/iv_header.png';
import styled from '@emotion/styled';
import { useContext } from 'react';
import { DemoContext } from '../Demo';

export const InnovidHeader: React.FunctionComponent = () => {
  const {isExternal} = useContext(DemoContext);
  return <InnovidHeaderContainer>
    {!isExternal &&
    <>
      <HeaderLogo src={logo}/>
      <HeaderSeparator/>
    </>
    }
    <HeaderTitle>CTV CREATIVE PREVIEW</HeaderTitle>
  </InnovidHeaderContainer>;
}

const InnovidHeaderContainer = styled.div`
  width: 100%;
  height: 5vh;
  background-color: #000000;
  padding-left: 1.5%;
  display: flex;
  align-items: center;
`;

const HeaderLogo = styled.img`
  margin: 0;
  height: 45%;
`;

const HeaderSeparator = styled.div`
  height: 40%;
  width: 1px;
  margin: 0 1%;
  background-color: #FFFFFFAA;
`;

const HeaderTitle = styled.div`
  font-family: proximanova-regular;
  font-size: 0.9vw;
  color: white;
  text-transform: uppercase;
`;
